import { useMutation } from '@tanstack/react-query';
import { updateAndValidateShoppingCart } from '../api/client';

export const useValidateShoppingCart = () => {
    const { mutateAsync: validateShoppingCart } = useMutation({
        mutationFn: (shoppingCartId: string) => {
            return updateAndValidateShoppingCart({ id: shoppingCartId });
        },
    });
    return validateShoppingCart;
}